<template>
  <div class="Interview_brief">
    <div class="nav">
      <h2>心理访谈情况简报</h2>
      <div class="cvs">
        <p>一、心理访谈学生的人数分布情况</p>
      </div>
      <p style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">{{Data.briefingPartOne
.publishSubject}}全校参加测评的总人数{{Data.briefingPartOne.totalParticipants}}人，被邀请参加心理访谈的学生{{Data.briefingPartOne.totalInvitedStudents}}名，分布在{{Data.briefingPartOne.distributedUnits}}个培养单位；最后到访学生共{{Data.briefingPartOne.finalVisitedStudents}}人，占全部受邀学生的{{Data.briefingPartOne.visitedStudentRatio}}%，这个数据{{Data.briefingPartOne.comparisonVisitingStudents}}于往年水平（往年约在{{Data.briefingPartOne.previousYearVisitedStudentRatio}} %）。</p>

      <p style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">全部受邀学生中，黄色等级{{Data.briefingPartOne.yellowLevel}}人，到访{{Data.briefingPartOne.yellowLevelVisited}}人，比率{{Data.briefingPartOne.yellowLevelVisitedRatio}}%；橙色等级{{Data.briefingPartOne.orangeLevel}}人，到访{{Data.briefingPartOne.orangeLevelVisited}}人，比率{{Data.briefingPartOne.orangeLevelVisitedRatio}}%；</p>

      <table>
        <thead>
          <tr>
            <th>风险等级</th>
            <th>等级人数</th>
            <th>到访人数</th>
            <th>比率</th>
          </tr>
        </thead>

        <tbody>
            <tr>
              <td>黄色等级</td>
              <td>{{Data.briefingPartOne.yellowLevel}}</td>
              <td>{{Data.briefingPartOne.yellowLevelVisited}}</td>
              <td>{{Data.briefingPartOne.yellowLevelVisitedRatio}}</td>
            </tr>
            <tr>
              <td>橙色等级</td>
              <td>{{Data.briefingPartOne.orangeLevel}}</td>
              <td>{{Data.briefingPartOne.orangeLevelVisited}}</td>
              <td>{{Data.briefingPartOne.orangeLevelVisitedRatio}}</td>
            </tr>
        </tbody>
      </table>

      <p style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">从男女生比例到访情况来看，女生（{{Data.briefingPartTwo.invitedYellowFemale + Data.briefingPartTwo.invitedOrangeFemale }}人）的到访率为{{Data.briefingPartTwo.femaleVisitationRate}}%，{{Data.briefingPartTwo.invitedMaleFemaleComparison}}于男生（{{Data.briefingPartTwo.invitedYellowMale + Data.briefingPartTwo.invitedOrangeMale }}人）{{Data.briefingPartTwo.maleVisitationRate}}%的到访率。</p>

      <table>
        <thead>
            <tr>
              <th>风险等级</th>
              <th>女生到访率</th>
              <th>男生到访率</th>
            </tr>
        </thead>

        <tbody>
            <tr>
                <td>黄色等级</td>
                <td>{{Data.briefingPartTwo.yellowFemaleVisitRate}}</td>
                <td>{{Data.briefingPartTwo.yellowMaleVisitRate}}</td>
            </tr>
            <tr>
                <td>橙色等级</td>
                <td>{{Data.briefingPartTwo.orangeFemaleVisitRate}}</td>
                <td>{{Data.briefingPartTwo.orangeMaleVisitRate}}</td>
            </tr>
        </tbody>
      </table>

      <p style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">在不同培养层次的学生中，{{Data.briefingPartThree.degreeName}}（ {{Data.briefingPartThree.invitedHigPeople}}人）占受邀访谈学生人数比例最高，达到{{Data.briefingPartThree.invitedHighestLevel}}%，本科生到访比率为{{Data.briefingPartThree.undergradRate}}%，硕士生（{{Data.briefingPartThree.invitedYellowMaster + Data.briefingPartThree.invitedOrangeMaster}}人，占受邀比{{Data.briefingPartThree.masterInvitationRatio}}%）和博士生（{{Data.briefingPartThree.invitedYellowDoctor + Data.briefingPartThree.invitedOrangeDoctor}}人，占受邀比{{Data.briefingPartThree.doctorInvitationRatio}}%）学生的到访率分别为{{Data.briefingPartThree.masterRate}}%和{{Data.briefingPartThree.doctorRate}}%。</p>

      <table>
        <thead>
              <tr>
                  <th>风险等级</th>
                  <th>本科生到访率</th>
                  <th>硕士生到访率</th>
                  <th>博士生到访率</th>
              </tr>
          </thead>
          <tbody>
              <tr>
                  <td>黄色等级</td>
                  <td>{{Data.briefingPartThree.yellowUndergradRate}}</td>
                  <td>{{Data.briefingPartThree.yellowMasterRate}}</td>
                  <td>{{Data.briefingPartThree.yellowDoctorRate}}</td>
              </tr>
              <tr>
                  <td>橙色等级</td>
                  <td>{{Data.briefingPartThree.orangeUndergradRate}}</td>
                  <td>{{Data.briefingPartThree.orangeMasterRate}}</td>
                  <td>{{Data.briefingPartThree.orangeDoctorRate}}</td>
              </tr>
          </tbody>
      </table>

      <p style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">到访率100%的培养单位有{{Data.briefingPartFour.deptNameCount}}个：{{Data.briefingPartFour.deptName}}。</p>

      <p style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">到访率排在后三位的学院有：{{Data.briefingPartFive}}。</p>

      <div class="cvs" style="width: 320px;">
        <p>二、访谈结果分析</p>
      </div>
      
      <p style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">1、到访组和未到访组心理状况{{Data.briefingPartSixVo.p005Result}}显著差异，即从测评结果来看，到访组同学和未到访组在心理测评数据上{{Data.briefingPartSixVo.p005Result}}显著差异，也就是说，<span v-if="Data.briefingPartSixVo.p005Result == '有'">到访的心理健康水平比不到访的{{Data.briefingPartSixVo.isX1GreaterThanX2}}，是否到访和心理状况有明显关系。</span>
      <span v-else-if="Data.briefingPartSixVo.p005Result == '无'">不能说到访的心理健康水平比不到访的好或差，是否到访和心理状况无明显关系。</span></p>


      <p style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">2、自杀想法情况。以访谈过程中报告是否有过自杀想法来分组，全部到访学生和后续参加访谈的学生中，否认自杀想法的学生 {{Data.briefingPartSeven.noSuicideThought}}人，占访谈学生的{{Data.briefingPartSeven.noSuicideThoughtRate}}%，其中女生{{Data.briefingPartSeven.noSuicideThoughtFemale}}人，男生{{Data.briefingPartSeven.noSuicideThoughtMale}}人；本科生{{Data.briefingPartSeven.noSuicideThoughtUndergraduate}}人，硕士生{{Data.briefingPartSeven.noSuicideThoughtMaster}}人，博士生{{Data.briefingPartSeven.noSuicideThoughtPhD}}人。</p>

      <p style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">有过自杀想法的学生{{Data.briefingPartSeven.hasSuicideThought}}人，占访谈学生的{{Data.briefingPartSeven.suicideThoughtRate}}%，其中女生{{Data.briefingPartSeven.hasSuicideThoughtFemale}}人，男生{{Data.briefingPartSeven.hasSuicideThoughtMale}}人；本科生{{Data.briefingPartSeven.hasSuicideThoughtUndergraduate}}人，硕士生{{Data.briefingPartSeven.hasSuicideThoughtMaster}}人，博士生{{Data.briefingPartSeven.hasSuicideThoughtPhD}}人。</p>

      <p style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">访谈中自杀风险等级为高的学生{{Data.briefingPartEight.highRisk}}人，占访谈学生的{{Data.briefingPartEight.highRiskRate}}%，其中女生{{Data.briefingPartEight.highRiskFemale}}人，男生{{Data.briefingPartEight.highRiskMale}}人；本科生{{Data.briefingPartEight.highRiskUndergraduate}}人，硕士生{{Data.briefingPartEight.highRiskMaster}}人，博士生{{Data.briefingPartEight.highRiskPhD}}人。</p>


      <p style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">自杀风险等级为中的学生{{Data.briefingPartEight.mediumRisk}}人，占访谈学生的{{Data.briefingPartEight.mediumRiskRate}}%，其中女生{{Data.briefingPartEight.mediumRiskFemale}}人，男生{{Data.briefingPartEight.mediumRiskMale}}人；本科生{{Data.briefingPartEight.mediumRiskUndergraduate}}人，硕士生{{Data.briefingPartEight.mediumRiskMaster}}人，博士生{{Data.briefingPartEight.mediumRiskPhD}}人。</p>


      <p style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">3、综合危机评估学生分布。 {{Data.briefingPartNine.totalVisitedStudents}}名受访学生中，评级为严重且紧急的{{Data.briefingPartNine.severeAndUrgent}}人，评级为重度的{{Data.briefingPartNine.severe}}人，评级为中度的{{Data.briefingPartNine.moderate}}人，评级为轻度的 {{Data.briefingPartNine.mild}}人，评级为良好的 {{Data.briefingPartNine.good}}人。</p>

      <table>
        <thead>
          <tr>
            <th>风险等级</th>
            <th>人数</th>
          </tr>
        </thead>
        
        <tbody>
          <tr>
            <td>严重且紧急（5级）</td>
            <td>{{Data.briefingPartNine.severeAndUrgent}}</td>
          </tr>
          <tr>
            <td>重度（4级）</td>
            <td>{{Data.briefingPartNine.severe}}</td>
          </tr>
          <tr>
            <td>中度（3级）</td>
            <td>{{Data.briefingPartNine.moderate}}</td>
          </tr>
          <tr>
            <td>轻度（2级）</td>
            <td>{{Data.briefingPartNine.mild}}</td>
          </tr>
          <tr>
            <td>良好（1级）</td>
            <td>{{Data.briefingPartNine.good}}</td>
          </tr>
        </tbody>
      </table>



      <p style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">访谈前后各风险等级变化情况：</p>
      
      <table>
        <thead>
          <tr>
            <th>风险等级</th>
            <th>人数</th>
          </tr>
        </thead>
        
        <tbody>
          <tr>
            <td>严重且紧急（5级）</td>
            <td>{{Data.briefingPartNine.severeAndUrgent}}</td>
          </tr>

          <tr>
            <td>重度（4级）</td>
            <td>{{(Data.briefingPartNine.severe - Data.briefingPartNine.preInterviewSevere -11) >0?'+' + Data.briefingPartNine.severe - Data.briefingPartNine.preInterviewSevere:Data.briefingPartNine.severe - Data.briefingPartNine.preInterviewSevere}}</td>
          </tr>
          <tr>
            <td>中度（3级）</td>
            <td>{{Data.briefingPartNine.moderate - Data.briefingPartNine.preInterviewModerate >0?'+'+Data.briefingPartNine.moderate - Data.briefingPartNine.preInterviewModerate:Data.briefingPartNine.moderate - Data.briefingPartNine.preInterviewModerate }}</td>
          </tr>

          <tr>
            <td>轻度（2级）</td>
            <td>{{Data.briefingPartNine.mild}}</td>
          </tr>
          <tr>
            <td>良好（1级）</td>
            <td>{{Data.briefingPartNine.good}}</td>
          </tr>
        </tbody>
      </table>

      <p style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">评级为评级为严重且紧急的{{Data.briefingPartNine.severeAndUrgent}}人，女生{{Data.briefingPartNine.severeAndUrgentFemale}}人，男生{{Data.briefingPartNine.severeAndUrgentMale}}人；本科生{{Data.briefingPartNine.severeAndUrgentUndergraduate}}人，硕士生{{Data.briefingPartNine.severeAndUrgentMaster}}人，博士生{{Data.briefingPartNine.severeAndUrgentPhD}}人；</p>

      <p style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">评级为重度的{{Data.briefingPartNine.severe}}人，女生{{Data.briefingPartNine.severeFemale}}人，男生{{Data.briefingPartNine.severeMale}}人；本科生{{Data.briefingPartNine.severeUndergraduate}}人，硕士生{{Data.briefingPartNine.severeMaster}}人，博士生{{Data.briefingPartNine.severePhD}}人；</p>

      <p style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">评级为中度的 {{Data.briefingPartNine.moderate}}人，女生{{Data.briefingPartNine.moderateFemale}}人，男生{{Data.briefingPartNine.moderateMale}}人；本科生{{Data.briefingPartNine.moderateUndergraduate}}人，硕士生{{Data.briefingPartNine.moderateMaster}}人，博士生{{Data.briefingPartNine.moderatePhD}}人。</p>


      <p style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">不同等级学生性别情况：</p>

      <table>
        <thead>
          <tr>
            <th>风险等级</th>
            <th>男生人数</th>
            <th>女生人数</th>
          </tr>
        </thead>
        
        <tbody>
          <tr v-if="Data.briefingPartNine.severeAndUrgent>0">
            <td>严重且紧急（5级）</td>
            <td>{{Data.briefingPartNine.severeAndUrgentMale}}</td>
            <td>{{Data.briefingPartNine.severeAndUrgentFemale}}</td>
          </tr>
          <tr v-if="Data.briefingPartNine.severe>0">
            <td>重度（4级）</td>
            <td>{{Data.briefingPartNine.severeMale}}</td>
            <td>{{Data.briefingPartNine.severeFemale}}</td>
          </tr>
          <tr v-if="Data.briefingPartNine.moderate >0">
            <td>中度（3级）</td>
            <td>{{Data.briefingPartNine.moderateMale}}</td>
            <td>{{Data.briefingPartNine.moderateFemale}}</td>
          </tr>
          <tr v-if="Data.briefingPartNine.mild > 0">
            <td>轻度（2级）</td>
            <td>{{Data.briefingPartNine.mildMale}}</td>
            <td>{{Data.briefingPartNine.mildFemale}}</td>
          </tr>
          <tr v-if="Data.briefingPartNine.good >0">
            <td>良好（1级）</td>
            <td>{{Data.briefingPartNine.goodMale}}</td>
            <td>{{Data.briefingPartNine.goodFemale}}</td>
          </tr>
        </tbody>
      </table>

      <p style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">不同等级学生培养层次情况：</p>

      <table>
        <thead>
            <tr>
              <th>风险等级</th>
              <th>本科生人数</th>
              <th>硕士生人数</th>
              <th>博士生人数</th>
            </tr>
        </thead>
        <tbody>
          <tr v-if="Data.briefingPartNine.severeAndUrgent>0">
            <td>严重且紧急（5级）</td>
            <td>{{Data.briefingPartNine.severeAndUrgentUndergraduate}}</td>
            <td>{{Data.briefingPartNine.severeAndUrgentMaster}}</td>
            <td>{{Data.briefingPartNine.severeAndUrgentPhD}}</td>
          </tr>
          <tr v-if="Data.briefingPartNine.severe>0">
            <td>重度（4级）</td>
            <td>{{Data.briefingPartNine.severeUndergraduate}}</td>
            <td>{{Data.briefingPartNine.severeMaster}}</td>
            <td>{{Data.briefingPartNine.severePhD}}</td>
          </tr>
          <tr v-if="Data.briefingPartNine.moderate >0">
            <td>中度（3级）</td>
            <td>{{Data.briefingPartNine.moderateUndergraduate}}</td>
            <td>{{Data.briefingPartNine.moderateMaster}}</td>
            <td>{{Data.briefingPartNine.moderatePhD}}</td>
          </tr>
          <tr v-if="Data.briefingPartNine.mild > 0">
            <td>轻度（2级）</td>
            <td>{{Data.briefingPartNine.mildUndergraduate}}</td>
            <td>{{Data.briefingPartNine.mildMaster}}</td>
            <td>{{Data.briefingPartNine.mildPhD}}</td>
          </tr>
          <tr v-if="Data.briefingPartNine.good >0">
            <td>良好（1级）</td>
            <td>{{Data.briefingPartNine.goodUndergraduate}}</td>
            <td>{{Data.briefingPartNine.goodMaster}}</td>
            <td>{{Data.briefingPartNine.goodPhD}}</td>
          </tr>
        </tbody>
      </table>

      <p style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">访谈后等级为3级及以上（含）情况（按从大到小排列）：</p>

      <table>
        <thead>
          <tr>
            <th>培养单位</th>
            <th>人数</th>
          </tr>
        </thead>

        <tbody v-if="Data.statistic.length>0">
          <tr v-for="(item,i) in Data.statistic" :key="i">
            <td>{{item.deptName}}</td>
            <td>{{item.personCount}}</td>
          </tr>
        </tbody>
      </table>

      <div class="cvs" style="width: 420px;">
        <p>附：普测量表简介</p>
      </div>
      
      <p v-if="ReportType == 2" style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">面向全体学生普测的检测采用的是SCL-90症状自评量表和青少年学生生活满意度。</p>

      <p v-if="ReportType == 2" style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;"><span style="font-weight: 700;">SCI-90症状自评量表</span> 是世界上最著名的心理健康测试量表之一。它可以从感觉、情感、思维、意识、行为直到生活习惯、人际关系、饮食睡眠等多种角度，评定一个人是否有某种心理症状及其严重程度如何。它对有心理症状(即有可能处于心理障碍或心理障碍边缘)的人有良好的区分能力。适用于测查某人群中哪些人可能有心理障碍、某人可能有何种心理障碍及其严重程度如何。</p>

      <p v-if="ReportType == 2" style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">本量表共90个自我评定项目。包含9个因子，分别为：躯体化、强迫症状、人际关系敏感、抑郁、焦虑、敌对、恐怖、偏执及精神病性。其中有一个轻生项目。量表第15题是反映轻生想法的项目。</p>

      <p v-if="ReportType == 2" style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;"><span style="font-weight: 700;">青少年学生生活满意度量表</span>由张兴贵和何立国于2004年编制，该量表以Huebner1994年编制的青少年多维生活满意度量表为基础，主要反映与青少年学生学习和生活有关的内容，是一个自评量表，采用七点评分方法，评估友谊、家庭、学业、自由、学校和环境6个维度的满意度情况，共36个条目。</p>
      <p v-if="ReportType == 1" style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">面向全体新生普测的检测采用的是卡特尔16种人格因素测验（16PF）、大学生心理健康问卷（UPI）、抑郁自评量表（SDS）、自杀态度问卷（QSA）。</p>


      <p v-if="ReportType == 1" style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;"><span style="font-weight: 700;">16种人格因素测验（16PF）</span>是由美国心理学家雷蒙德·卡特尔（Raymond B. Cattell）于20世纪中期开发的一种人格测评工具。卡特尔通过因素分析的方法，从大量的人格描述词汇中提炼出16种核心人格特质。他认为这些特质是人格的基本维度，能够解释个体在不同情境下的行为差异。该测验基于卡特尔的人格特质理论，旨在测量个体在16种基本人格特质上的表现。这些特质被认为是构成人格的基本单元，能够全面反映个体的性格特征，共包含约187道题目，测验时间约为30-50分钟，适用于16岁以上的个体，分析维度包括乐群性、敢为性、敏感性等人格特征维度。</p>

      <p v-if="ReportType == 1" style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;"><span style="font-weight: 700;">大学生心理健康问卷（UPI）</span>是为了早期发现、早期治疗有心理问题的学生而编制的大学生精神卫生、人格健康调查量表。该量表1966年由日本大学的心理咨询专家与精神科医生集体编制而成。1991年，由日本学生相谈学会会长松原达哉与樊富珉翻译介绍给国内。1993年，由樊富珉、王建中主持全国UPI应用课题研究，对UPI的有关条目、筛选标准，实施过程等进行了较为系统的修订，目前，已成为国内大学的心理咨询机构普测的常用量表。</p>

      <p v-if="ReportType == 1" style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;"><span style="font-weight: 700;">抑郁自评量表（SDS）</span>是由William W.K. Zung于1965年编制的一种用于评估个体抑郁状态的自我报告式心理测量工具。该量表主要用于初步筛查抑郁症状的严重程度，适用于成年人及青少年。SDS因其简便、易操作的特点，广泛应用于临床、科研和教育领域。SDS包含20个题目，采用4级评分法，根据症状出现的频率进行评分，是一种简便、有效的抑郁症状评估工具，适用于初步筛查和抑郁水平的自我评估。</p>
      <p v-if="ReportType == 1" style="color: rgba(18, 18, 18, 1);font-size: 18px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;padding-bottom:20px"><span style="font-weight: 700;">自杀态度问卷（QSA）</span>是一种用于评估个体对自杀行为的态度和看法的心理测量工具。该问卷旨在了解个体对自杀的认知、情感和行为倾向，为自杀风险的评估和干预提供参考。QSA通常用于心理健康研究、临床评估以及自杀预防工作，可用于学校、社区等群体的心理健康筛查。QSA包含29个题目，涵盖个体对自杀的态度、信念和情感反应。</p>
      <div style="height: 30px;"></div>
    </div>

    
    <el-button type="primary" style="position: fixed;top:200px;right:20px" @click="dcfub()">导出</el-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      Data:'',
      ReportType:''
    }
  },
  methods: {
    dcfub(){
        var publishID = [this.$route.query.PaperResultID][0];
        this.$Http_Post('interview/interviewBriefingWord', { publishID: publishID,type:[this.$route.query.ReportType][0]}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          window.open(res.Data, '_blank');
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
  },
  mounted() {
    var PaperResultID = [this.$route.query.PaperResultID][0];
    this.ReportType = [this.$route.query.ReportType][0];
    this.$Http_Post('/interview/briefingData',{"publishID":PaperResultID}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.Data = res.Data
      }else{
        this.$router.push({path: "/Client/PuceReport"});
        this.Global.request_failure(res.Message);
      }
    })
  },
}
</script>
<style>
.Interview_brief {width: 100%;height: 100%;background: #fff;}
.Interview_brief .nav{width: 1000px;margin: auto;height: 100%;background-image: url('../../assets/dgewccve.png');overflow: auto;background-size:1000px}
.Interview_brief .nav h2{font-size: 28px;color: rgba(0, 103, 202, 1);text-align: center;padding-top: 20px;}
.Interview_brief .nav .cvs{margin-left: -20px;margin-top: 20px;transform: skewX(-30deg);width: 460px;height: 56px;background: linear-gradient(270deg, rgba(228, 241, 255, 1) 0%, rgba(140, 196, 255, 1) 100%);line-height: 55px;color: rgba(0, 70, 145, 1);font-weight: 700;font-size: 16px;font-style: italic;}
.Interview_brief .nav .cvs p{transform: skewX(40deg);margin-left: 50px;}
.Interview_brief table {border-collapse: collapse; width: 80%;margin: 20px auto;font-family: Arial, sans-serif;}
.Interview_brief th,td {border: 1px solid #ddd;padding: 12px;text-align: left;text-align: center;}
th {background-color: #f2f2f2;color: #333;}
.Interview_brief tr:hover {background-color: #e5f6ff;}
</style>
